import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.PersonFilters;

// initial state
// object name must match specification name
const filters = {
	StateCode: new FormControl.FilterGroup('StateCode', 'Filter by State', 'All States', '', false, true, 'checkbox'),
	ResearchTopic: new FormControl.FilterGroup('ResearchTopic', 'Filter by Topic', 'Select a Topic', '', false, true, 'checkbox'),
	ResearchDisease: new FormControl.FilterGroup('ResearchDisease', 'Filter by Disease', 'Select a Disease', '', false, true, 'checkbox'),
	ResearchGrant: new FormControl.FilterGroup('ResearchGrant', 'Filter by Grant', 'Select a Grant', '', false, true, 'checkbox'),
    searchTerm: new FormControl.FilterGroup(
		'SearchTerm', 'Search by Keyword', null, null, false, true, 'textbox',
		new FormControl.Textbox('Search')
	),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };